import script from "./adminInspector.vue?vue&type=script&setup=true&lang=ts"
export * from "./adminInspector.vue?vue&type=script&setup=true&lang=ts"

import "./adminInspector.vue?vue&type=style&index=0&id=e8468c22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8468c22"]])

export default __exports__